import { generatePath } from 'react-router-dom';

import { doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type {
  AuthorizeOpenTableOAuthRequest,
  AuthorizeOpenTableOAuthResponse,
  CreateOpenTableIntegrationRequest,
  CreateOpenTableIntegrationResponse,
  CreateOpenTableUserRequest,
  CreateOpenTableUserResponse,
  GetOpenTableIntegrationRequest,
  GetOpenTableIntegrationResponse,
  UpdateOpenTableIntegrationRequest,
  UpdateOpenTableIntegrationResponse,
} from './types';

export const getOpenTableIntegration = (
  request: GetOpenTableIntegrationRequest,
) => {
  return doGet<GetOpenTableIntegrationResponse>(
    generatePath('internal/opentable/get', request),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'api',
      version: 'v2',
    },
  );
};

export const createOpenTableIntegration = (
  request: CreateOpenTableIntegrationRequest,
) => {
  return doPost<CreateOpenTableIntegrationResponse>(
    'internal/opentable/create',
    LOGGER_TYPE.JUPITER,
    request,
    {
      prefix: 'api',
      version: 'v2',
    },
  );
};

export const updateOpenTableIntegration = (
  request: UpdateOpenTableIntegrationRequest,
) => {
  return doPatch<UpdateOpenTableIntegrationResponse>(
    'internal/opentable/update',
    LOGGER_TYPE.JUPITER,
    request,
    {
      prefix: 'api',
      version: 'v2',
    },
  );
};

export const createOpenTableUser = (request: CreateOpenTableUserRequest) => {
  return doPost<CreateOpenTableUserResponse>(
    'internal/opentable/user',
    LOGGER_TYPE.JUPITER,
    request,
    {
      prefix: 'api',
      version: 'v2',
    },
  );
};

export const authorizeOpenTableOAuth = (
  request: AuthorizeOpenTableOAuthRequest,
) => {
  return doPost<AuthorizeOpenTableOAuthResponse>(
    'opentable/oauth/authorize',
    LOGGER_TYPE.JUPITER,
    request,
    {
      prefix: 'api',
      version: 'v2',
    },
  );
};
